import { dateFormat, isoDateFormat } from 'client-portal/utils/date-time';
import moment from 'moment-timezone';

const SUPPORTED_INPUT_FORMATS = [isoDateFormat, dateFormat];

export function deserializeBirthDate(value) {
  if (value === null || value === undefined || value === '') return null;
  if (moment.isMoment(value)) return value.isValid() ? value : null;
  if (typeof value !== 'string') return null;

  for (const format of SUPPORTED_INPUT_FORMATS) {
    const strict = moment(value, format, true);
    if (strict.isValid()) return strict;
  }

  // Legacy ISO datetimes (e.g. "1995-07-03T00:00:00.000Z") must keep their
  // original calendar day regardless of the local timezone, so read the date
  // portion in UTC and rebuild a date-only moment in local time.
  const utc = moment.utc(value);
  if (!utc.isValid()) return null;
  return moment(utc.format(isoDateFormat), isoDateFormat, true);
}

export function serializeBirthDate(value) {
  if (!moment.isMoment(value) || !value.isValid()) return null;
  return value.format(isoDateFormat);
}
